/* BEBA YERBA · My BEBA dashboard: copy discount codes, email/text sign-up (Klaviyo, same lists as the homepage). */
(function(){
  var toast=document.getElementById('mb-toast'),tt;
  function say(t){if(!toast)return;toast.textContent=t;toast.hidden=false;clearTimeout(tt);tt=setTimeout(function(){toast.hidden=true},2400)}

  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-copy]');if(!b)return;
    var code=b.getAttribute('data-copy');
    var done=function(){say('Code '+code+' copied. Paste it at checkout.')};
    if(navigator.clipboard&&navigator.clipboard.writeText)navigator.clipboard.writeText(code).then(done,function(){say('Your code: '+code)});
    else say('Your code: '+code);
  });

  var f=document.getElementById('mb-offers');if(!f||!window.fetch)return;
  var co=f.dataset.company,emailList=f.dataset.emailList,smsList=f.dataset.smsList,msg=f.querySelector('.mb-msg');
  var note=function(t,ok){msg.textContent=t;msg.hidden=false;msg.setAttribute('role',ok?'status':'alert')};
  var sub=function(list,attrs){return fetch('https://a.klaviyo.com/client/subscriptions?company_id='+encodeURIComponent(co),{method:'POST',headers:{'Content-Type':'application/vnd.api+json','revision':'2024-10-15'},
    body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:'BEBA website · My BEBA',profile:{data:{type:'profile',attributes:attrs}}},relationships:{list:{data:{type:'list',id:list}}}}})}).then(function(r){if(!r.ok)throw new Error(String(r.status))})};
  f.addEventListener('submit',function(e){
    e.preventDefault();
    var em=f.querySelector('input[type=email]'),ph=f.querySelector('input[name=phone]'),btn=f.querySelector('button[type=submit]');
    var email=(em.value||'').trim();
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){note('Enter an email address like name@example.com.');em.focus();return}
    var phone='';
    if(ph&&ph.value.trim()){var d=ph.value.replace(/\D/g,'');if(d.length===10)d='1'+d;if(d.length!==11||d.charAt(0)!=='1'){note('Enter a 10-digit US mobile number, or leave it blank.');ph.focus();return}phone='+'+d}
    btn.disabled=true;note('Signing you up…',true);
    var jobs=[sub(emailList,{email:email})];
    if(phone&&smsList)jobs.push(sub(smsList,{email:email,phone_number:phone}));
    Promise.allSettled(jobs).then(function(r){
      btn.disabled=false;
      if(r[0].status!=='fulfilled'){note('That didn’t go through. Please try again in a minute.');return}
      var t="You're in. Watch your inbox for your welcome code.";
      if(phone&&smsList)t+=r[1].status==='fulfilled'?' Reply YES to the text we just sent to confirm.':' Your number didn’t go through, try again later.';
      note(t,true);
      try{window.klaviyo&&window.klaviyo.identify({email:email})}catch(x){}
    });
  });
})();
